/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

const __vue_script__ = {
    name: 'PackageInspector',

    components: { SearchBar, SmartTable },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            packages: [],
            searchTerm: '',
            limit: 50
        };
    },

    computed: {
        visiblePackages() {
            const search = this.searchTerm.toLowerCase().trim();
            return this.packages.filter(pkg => {
                const nameUserOperation = `${pkg.name} ${pkg.user} ${pkg.operation}`;
                const docsRevs = pkg.results.map(result => `${result.id} ${result.rev}`).join(' ');
                const errors = pkg.errors.map(item => item.error.error || item.error.reason).join(' ');
                const matchString = `${nameUserOperation} ${docsRevs} ${errors}`;
                return matchString.toLowerCase().includes(search);
            });
        }
    },

    created() {
        this.loadPackages();
    },

    methods: {
        async loadPackages() {
            try {
                const { rows } = await this.$services.appScripts.callAppScript(this.params.event._id, 'dev-tools/get-installed-pkg');
                this.packages = rows.map(this.mapPackageReport).sort((a, b) => b.timestamp - a.timestamp);
            } catch (error) {
                console.error('[PackageInspector] Error loading packages', error);
            }
        },

        mapPackageReport({ value }) {
            const report = value.report || { results: [] };
            const results = report.results.filter(r => r.id && r.rev);
            const errors = report.errors || [];
            const { _id, pkg, version, timestamp, operation, bstg_user_id } = value;

            return {
                _id,
                name: pkg || '<unknown>',
                version,
                operation,
                timestamp: new Date(timestamp).getTime(),
                user: this.$utils.strings.emailFromUserId(bstg_user_id) || '<system>',
                modified: results.length,

                // shortcut for common content
                has: {
                    appscript: results.some(result => result.id === 'appscripts'),
                    handler: results.some(result => result.id === '_design/nodehandlers'),
                    backstage: results.some(result => result.id.includes('_design/backstage_')),
                    frontstage: results.some(result => result.id.includes('_design/frontstage-') || result.id.includes('frontstage-'))
                },
                results,
                errors
            };
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "package-inspector" },
    [
      _c("h1", [_vm._v("List of packages operations")]),
      _c("smart-table", {
        ref: "table",
        attrs: {
          "track-by": "_id",
          "full-list-provided": true,
          "items-per-page": _vm.limit,
          items: _vm.visiblePackages,
          "auto-rows": true,
          "total-items": this.packages.length,
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function (ref) {
              return [
                _c("p", { staticClass: "intro" }, [
                  _vm._v(
                    "You can search by modified document ID and revision, package name, user, operation."
                  ),
                ]),
              ]
            },
          },
          {
            key: "filters",
            fn: function (ref) {
              return [
                _c("search-bar", {
                  attrs: { "show-no-result": false },
                  model: {
                    value: _vm.searchTerm,
                    callback: function ($$v) {
                      _vm.searchTerm = $$v
                    },
                    expression: "searchTerm",
                  },
                }),
              ]
            },
          },
          {
            key: "headers",
            fn: function (ref) {
              return [
                _c("th", [_vm._v("Package")]),
                _c("th", [_vm._v("Version")]),
                _c("th", [_vm._v("Installed")]),
                _c("th", [_vm._v("User")]),
                _c("th", [_vm._v("Modified")]),
                _c("th", [_vm._v("Context")]),
                _c("th", [_vm._v("Operation")]),
              ]
            },
          },
          {
            key: "row",
            fn: function (ref) {
              var pkg = ref.item
              return [
                _c(
                  "td",
                  { staticClass: "name" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "tools_document_editor_edit",
                            params: { docId: pkg._id },
                          },
                        },
                      },
                      [_vm._v(_vm._s(pkg.name))]
                    ),
                  ],
                  1
                ),
                _c("td", { staticClass: "version" }, [
                  _vm._v(_vm._s(pkg.version)),
                ]),
                _c("td", { staticClass: "installed" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$utils.time.tsToFormat(
                        pkg.timestamp,
                        "LLLL (z)",
                        "GMT"
                      )
                    )
                  ),
                ]),
                _c("td", { staticClass: "user" }, [_vm._v(_vm._s(pkg.user))]),
                _c("td", { staticClass: "modified" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "dev_tools.pkg_inspector.modified",
                        pkg.modified,
                        [pkg.modified]
                      )
                    )
                  ),
                ]),
                _c("td", { staticClass: "context" }, [
                  _c("div", { staticClass: "changes" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t(
                              "dev_tools.pkg_inspector.contexts.appscript"
                            ),
                            expression:
                              "$t('dev_tools.pkg_inspector.contexts.appscript')",
                          },
                        ],
                        staticClass: "badge appscript",
                        class: { invisible: !pkg.has.appscript },
                      },
                      [_vm._v("A")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t(
                              "dev_tools.pkg_inspector.contexts.handler"
                            ),
                            expression:
                              "$t('dev_tools.pkg_inspector.contexts.handler')",
                          },
                        ],
                        staticClass: "badge handler",
                        class: { invisible: !pkg.has.handler },
                      },
                      [_vm._v("H")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t(
                              "dev_tools.pkg_inspector.contexts.backstage"
                            ),
                            expression:
                              "$t('dev_tools.pkg_inspector.contexts.backstage')",
                          },
                        ],
                        staticClass: "badge backstage",
                        class: { invisible: !pkg.has.backstage },
                      },
                      [_vm._v("B")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t(
                              "dev_tools.pkg_inspector.contexts.frontstage"
                            ),
                            expression:
                              "$t('dev_tools.pkg_inspector.contexts.frontstage')",
                          },
                        ],
                        staticClass: "badge frontstage",
                        class: { invisible: !pkg.has.frontstage },
                      },
                      [_vm._v("F")]
                    ),
                  ]),
                ]),
                _c("td", { staticClass: "operation" }, [
                  _c(
                    "div",
                    { staticClass: "operation", class: pkg.operation },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$te(
                            "dev_tools.pkg_inspector.operations." +
                              pkg.operation
                          )
                            ? _vm.$t(
                                "dev_tools.pkg_inspector.operations." +
                                  pkg.operation
                              )
                            : pkg.operation
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/dev-tools/PackageInspector.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__